import React from 'react'
import {
  formatMs,
  getExceptionType,
  hhmmADoMMMYYYY,
  isNullUndefinedAndEmpty
} from '@fareye/utils'
import { displayTime } from '../../utility/function'
// import { Exception } from '../../utils/types'
import { useTranslation } from '@fareye/common'

export default function ExceptionInfoWindow({
  exception,
  type = ''
}: {
  exception: any
  type?: string
}) {
  const { t } = useTranslation()
  const {
    type: exceptionType,
    escalatedTo,
    speed,
    duration,
    distance,
    createdAt
  } = exception || {}
  let speedStr = `${isNullUndefinedAndEmpty(speed) ? '-' : speed + ' Km/hr'}`

  return (
    <div>
      <p style={{ fontWeight: 'bold', fontSize: 18 }}>
        <strong>
          {exceptionType ? t(getExceptionType(exceptionType)) : null}
        </strong>
      </p>
      <hr />
      {escalatedTo && (
        <>
          <strong>{t('Escalated To')}</strong>: {escalatedTo}
        </>
      )}
      <br />
      {!!speed ? (
        <>
          <strong>{t('Speed')} </strong>:{speedStr}
          <br />
        </>
      ) : null}
      {!!duration ? (
        <>
          <strong>{t('Duration')} </strong>: {formatMs(duration)}
          <br />
        </>
      ) : null}
      {distance && (
        <>
          <strong>{t('Distance')} </strong>:
          {distance < 1
            ? `${Math.floor(Number(distance) * 1000)} ${t('Km')}`
            : `${distance} ${'Km'}`}
          <br />
        </>
      )}
      <strong>{t('Time')}</strong>
      {type === 'UTC'
        ? displayTime(createdAt)
        : hhmmADoMMMYYYY(new Date(createdAt))}
      <br />
    </div>
  )
}
